import _Auth from './_shared/Auth'
import _AuthWithToken from './_shared/AuthWithToken'
import _LogoutLink from './_shared/LogoutLink'
import _PermissionChecker from './_shared/PermissionChecker'

// Everithing that should be accessible outside
// this module, should be exported here

export const Auth = _Auth
export const AuthWithToken = _AuthWithToken
export const LogoutLink = _LogoutLink
export const PermissionChecker = _PermissionChecker
